import { GzInfoOverlayWebComponent } from './component/GzInfoOverlayWebComponent';
import { GzOverlay } from './component/InfoOverlay';

export { GzInfoOverlayWebComponent, GzOverlay };
